import { useEffect } from "react";
import Index from "./Index";
import { useLanguage } from "@/contexts/LanguageContext";

export default function ArIndex() {
  const { setLanguage } = useLanguage();

  useEffect(() => {
    setLanguage("ar");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Index />;
}
